module.exports = __webpack_public_path__ + "img/news1.75dd5c2c.jpg";